import { RootState } from "@src/store";
import { createSelector } from "@reduxjs/toolkit";
import { IDronesInitialState } from "./state";
import { DronesPageCollapseStatus } from "@src/features/drone/utils/operational-drones";

const selectDroneReducer = (state: RootState): IDronesInitialState =>
  state.DronePageReducer;

export const selectDroneState = createSelector(
  [selectDroneReducer],
  (state) => state
);

export const selectCollapse = createSelector(
  [selectDroneState],
  (state) => state.collapse
);

export const selectSelectedDrone = createSelector(
  [selectDroneState],
  (state) => state.selectedDrone
);

export const selectCollapseToggler = createSelector(
  [selectDroneState],
  (state) =>
    (status: DronesPageCollapseStatus) => ({
      ...state.collapse,
      [status]: !state.collapse[status],
    })
);

export const selectMapLocation = createSelector(
  [selectDroneState],
  (state) => state.location
);

export const selectShowTakeoffConfirm = createSelector(
  [selectDroneState],
  (state) => state.showTakeoffConfirm
);

export const selectMissionId = createSelector(
  [selectDroneState],
  (state) => state.missionId
);

export const selectHoveredDrone = createSelector(
  [selectDroneState],
  (state) => state.hoveredDrone
);

export const selectManualControlMap = createSelector(
  [selectDroneState],
  (state) => state.manualControl
);

export const selectManualControl = (serialNumber: string | undefined) =>
  createSelector(
    [selectManualControlMap],
    (manualControlMap) => serialNumber ? (manualControlMap[serialNumber] ?? false) : false
  );

export const selectOptimisticMissionSerials = createSelector(
  [selectDroneState],
  (state) => state.optimisticMissionSerials
);

export const selectEndedMissionSerials = createSelector(
  [selectDroneState],
  (state) => state.endedMissionSerials
);
